/* eslint-disable max-classes-per-file */
import { AnalyticsEvent } from '@shure/shared/models';

import { CdmAnalyticsEvents } from './cdm-analytics-events.enum';
import { AnalyticsCommonDeviceInfo } from './common.model';

export enum AddDeviceMethod {
	MacSerialIndividual = 'mac_serial_individual',
	MacSerialCsvFile = 'mac_serial_csv_file',
	QrCode = 'qr_code',
	LocalNetworkScanning = 'local_network_scanning'
}

interface AddDevicesByMacSerialEventProperties {
	method: AddDeviceMethod.MacSerialIndividual | AddDeviceMethod.MacSerialCsvFile | AddDeviceMethod.QrCode;
	devices: Pick<AnalyticsCommonDeviceInfo, 'mac' | 'serial'>[];
}

interface AddDevicesByLocalNetworkScanningEventProperties {
	method: AddDeviceMethod.LocalNetworkScanning;
	devices: AnalyticsCommonDeviceInfo[];
}

/**
 * To measure how frequenty a user launches the Add Devices dialog
 */
export class AddDevicesDialogLaunchedEvent implements AnalyticsEvent {
	public readonly event = CdmAnalyticsEvents.AddDevicesDialogLaunched;
	public readonly properties = {};
}

/**
 * To measure how frequenty a user cancels out of the Add Devices dialog w/out adding any devices
 */
export class AddDevicesDialogCancelledEvent implements AnalyticsEvent {
	public readonly event = CdmAnalyticsEvents.AddDevicesDialogCancelled;
	public readonly properties: {
		step: 'step_1' | 'step_2';
	};

	constructor(step: 'step_1' | 'step_2') {
		this.properties = { step };
	}
}

/**
 * To measure which method of the AddDevices dialog is used the most.
 *
 * This event would get tracked after the user selects one of the methods from Step 1 of the dialog,
 * proceeds through all the steps to add the devices to the BE, then clicks the action to submit the request to the server.
 *
 * To be clear, the event will not be tracked until the user has committed to adding the devices.
 * It won't track the cases where a user opens the dialog, clicks around a little, then cancels out.
 */
export class AddDevicesDialogDevicesAddedEvent implements AnalyticsEvent {
	public readonly event = CdmAnalyticsEvents.AddDevicesDialogDevicesAdded;
	public readonly properties: AddDevicesByMacSerialEventProperties | AddDevicesByLocalNetworkScanningEventProperties;

	constructor(properties: AddDevicesByMacSerialEventProperties | AddDevicesByLocalNetworkScanningEventProperties) {
		this.properties = properties;
	}
}
